import React from 'react';
import { Phone, MessageSquare, Zap, Shield, Wrench, Sun } from 'lucide-react';

const BRAND_COLORS = {
  primary: '#005691',
  secondary: '#6E6E6E',
};

export default function App() {
  return (
    <div style={{ fontFamily: 'sans-serif', backgroundColor: '#fff', color: '#333' }}>
      <header style={{ backgroundColor: BRAND_COLORS.primary, padding: '1rem', color: 'white', textAlign: 'center' }}>
        <h1>CWA (KZN)</h1>
      </header>

      <section style={{ padding: '1.5rem', textAlign: 'center' }}>
        <h2 style={{ color: BRAND_COLORS.primary }}>Reliable Electrical & Electronic Contracting</h2>
        <p style={{ color: BRAND_COLORS.secondary }}>Serving KZN with professional, certified electrical solutions.</p>
        <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ backgroundColor: BRAND_COLORS.primary, color: 'white', padding: '0.5rem 1rem', border: 'none', borderRadius: '5px' }}>
            <Phone size={16} style={{ marginRight: '5px' }} /> Call Now
          </button>
          <button style={{ backgroundColor: BRAND_COLORS.secondary, color: 'white', padding: '0.5rem 1rem', border: 'none', borderRadius: '5px' }}>
            <MessageSquare size={16} style={{ marginRight: '5px' }} /> WhatsApp
          </button>
        </div>
      </section>

      <section style={{ padding: '1.5rem' }}>
        <h3 style={{ color: BRAND_COLORS.primary }}>Our Services</h3>
        <div style={{ display: 'grid', gap: '1rem', marginTop: '1rem' }}>
          {[
            { icon: Zap, title: 'Electrical Installations', desc: 'Wiring, lighting, and full electrical fit-outs.' },
            { icon: Shield, title: 'CCTV & Security', desc: 'High-quality surveillance and security systems.' },
            { icon: Sun, title: 'Solar Solutions', desc: 'Energy-saving solar and backup systems.' },
          ].map((service, i) => (
            <div key={i} style={{ border: `2px solid ${BRAND_COLORS.primary}`, padding: '1rem', borderRadius: '10px', textAlign: 'center' }}>
              <service.icon size={28} style={{ color: BRAND_COLORS.primary }} />
              <h4>{service.title}</h4>
              <p style={{ color: BRAND_COLORS.secondary }}>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <footer style={{ backgroundColor: BRAND_COLORS.primary, color: 'white', padding: '1rem', textAlign: 'center' }}>
        © {new Date().getFullYear()} CWA (KZN). All rights reserved.
      </footer>
    </div>
  );
}
